import React from 'react';
import styled from 'styled-components';
import { registry } from '../../core/Registry.js';

const Wrapper = styled.div`
  width: ${props => props.width || '100%'};
  max-width: 600px;
  margin: ${props => props.align === 'center' ? '0 auto' : (props.align === 'right' ? '0 0 0 auto' : '0')};
  background: var(--glass-1);
  border: 1px solid var(--glass-border);
  border-radius: 16px;
  overflow: hidden;
  backdrop-filter: blur(10px);
`;

const Header = styled.div`
  background: linear-gradient(135deg, #022069, #0336a6);
  padding: 30px;
  color: #fff;
  text-align: center;
`;

const Title = styled.h2`
  margin: 0 0 10px 0;
  font-size: 24px;
`;

const Subtitle = styled.p`
  margin: 0;
  font-size: 14px;
  color: rgba(255,255,255,0.8);
`;

const FormBody = styled.div`
  padding: 30px;
  
  label {
    display: block;
    font-size: 12px;
    font-weight: 600;
    color: var(--text-secondary);
    margin-bottom: 6px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }
`;

const Row = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 15px;
  margin-bottom: 15px;

  @media(max-width: 500px) {
    grid-template-columns: 1fr;
  }
`;

const Input = styled.input`
  width: 100%;
  background: rgba(0,0,0,0.2);
  border: 1px solid var(--glass-border);
  padding: 12px;
  border-radius: 8px;
  color: var(--text-primary);
  outline: none;
  font-family: inherit;

  &:focus { border-color: var(--accent); }
`;

const Textarea = styled.textarea`
  width: 100%;
  background: rgba(0,0,0,0.2);
  border: 1px solid var(--glass-border);
  padding: 12px;
  border-radius: 8px;
  color: var(--text-primary);
  outline: none;
  font-family: inherit;
  min-height: 100px;
  resize: vertical;
  margin-bottom: 20px;

  &:focus { border-color: var(--accent); }
`;

const SubmitBtn = styled.button`
  width: 100%;
  background: var(--accent);
  color: #fff;
  font-weight: bold;
  font-size: 16px;
  padding: 15px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  box-shadow: 0 4px 15px var(--accent-glow);
`;

const O2BusinessContactWidget = ({ node }) => {
  return (
    <Wrapper align={node.style?.desktop?.align}>
      <Header>
        <Title>{node.content?.title || 'O₂ Business Beratung'}</Title>
        <Subtitle>{node.content?.subtitle || 'Lassen Sie sich kostenlos zu unseren B2B Tarifen und IoT Lösungen beraten.'}</Subtitle>
      </Header>
      <FormBody>
        <Row>
          <div>
            <label>Firmenname</label>
            <Input type="text" placeholder="Ihre Firma GmbH" />
          </div>
          <div>
            <label>Mitarbeiterzahl</label>
            <select style={{width:'100%', padding:'12px', borderRadius:'8px', background:'rgba(0,0,0,0.2)', border:'1px solid var(--glass-border)', color:'var(--text-primary)'}}>
              <option>1-10</option>
              <option>11-50</option>
              <option>51-200</option>
              <option>200+</option>
            </select>
          </div>
        </Row>
        <Row>
          <div>
            <label>Vor- & Nachname</label>
            <Input type="text" placeholder="Max Mustermann" />
          </div>
          <div>
            <label>Geschäftliche E-Mail</label>
            <Input type="email" placeholder="max@firma.de" />
          </div>
        </Row>
        <label>Ihre Anforderungen</label>
        <Textarea placeholder="z.B. Wir benötigen 50 neue 5G Tarife..." />
        
        <SubmitBtn className="tef-bubbles">Unverbindlich Anfragen</SubmitBtn>
      </FormBody>
    </Wrapper>
  );
};

registry.register('o2_business_contact', {
  label: 'B2B Kontakt (Lead)',
  icon: '🏢',
  category: 'tef_specific',
  defaultContent: {},
  defaultStyle: { desktop: { align: 'center' } },
  render: O2BusinessContactWidget,
  inspectorControls: [
    { tab: 'content', groups: [{ title: 'Header', fields: [{name:'content.title', label:'Titel', type:'text'}, {name:'content.subtitle', label:'Untertitel', type:'textarea'}] }] },
    { tab: 'style', groups: [{ title: 'Layout', fields: [{name:'style.desktop.align', label:'Ausrichtung', type:'select', options:[{label:'Zentriert', value:'center'},{label:'Links', value:'flex-start'}]}] }] }
  ]
});
